module.exports = __webpack_public_path__ + "img/aquatic-staff-3.132c79ae.jpg";